import type { TimerMode } from "../../tools/timerLogic";

export type WorldClockWidget = {
  type: "world_clock";
  timezoneId: string;
};

export type TimerWidget = {
  type: "timer";
  mode: TimerMode;
};

export type SidebarWidget = WorldClockWidget | TimerWidget;

export const SIDEBAR_WIDGETS_KEY = "trifecta-sidebar-widgets";
export const MAX_SIDEBAR_WIDGETS = 4;

export function loadSidebarWidgets(): SidebarWidget[] {
  try {
    const raw = localStorage.getItem(SIDEBAR_WIDGETS_KEY);
    if (!raw) return [];

    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((item): item is SidebarWidget => isSidebarWidget(item))
      .slice(0, MAX_SIDEBAR_WIDGETS);
  } catch {
    return [];
  }
}

export function saveSidebarWidgets(widgets: SidebarWidget[]): void {
  localStorage.setItem(
    SIDEBAR_WIDGETS_KEY,
    JSON.stringify(widgets.slice(0, MAX_SIDEBAR_WIDGETS)),
  );
}

export function canAddSidebarWidget(widgets: SidebarWidget[]): boolean {
  return widgets.length < MAX_SIDEBAR_WIDGETS;
}

export function hasTimerWidget(
  widgets: SidebarWidget[],
  mode: TimerMode,
): boolean {
  return widgets.some(
    (widget) => widget.type === "timer" && widget.mode === mode,
  );
}

function isSidebarWidget(item: unknown): item is SidebarWidget {
  if (typeof item !== "object" || item === null) return false;

  const widget = item as SidebarWidget;
  if (widget.type === "world_clock") {
    return typeof widget.timezoneId === "string";
  }

  if (widget.type === "timer") {
    return widget.mode === "countdown" || widget.mode === "stopwatch";
  }

  return false;
}
